var _rect, _g, _rect2, _rect3, _rect4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroBgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 234,
    viewBox: "0 0 375 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3933_36036)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 234,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3933_36036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.18 -11.1978C383.18 57.965 326.602 114.169 256.641 114.169C186.679 114.169 130.102 57.965 130.102 -11.1978C130.102 -80.3606 186.679 -136.565 256.641 -136.565C326.602 -136.565 383.18 -80.3606 383.18 -11.1978Z",
    stroke: "black",
    strokeWidth: 18.5365
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.3853,
    cy: 13.3853,
    r: 13.3853,
    transform: "matrix(-0.186751 -0.982407 -0.982407 0.186751 63.3208 29.0349)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.4085,
    cy: 14.4085,
    r: 14.4085,
    transform: "matrix(0.894157 -0.447754 -0.447754 -0.894157 140.896 106.45)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.542,
    cy: 30.5205,
    r: 16.5968,
    transform: "rotate(95.7089 262.542 30.5205)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.081,
    cy: -36.9922,
    r: 93.2834,
    transform: "rotate(95.7089 171.081 -36.9922)",
    stroke: "black",
    strokeWidth: 26.0417
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.166,
    cy: 15.5613,
    r: 16.5968,
    transform: "rotate(95.7089 343.166 15.5613)",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 374.4,
    fill: "#878787"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 374.4,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 374.4,
    transform: "translate(0 -0.000488281)",
    fill: "#FFD550"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3933_36036",
    x: 9.80452,
    y: -170.312,
    width: 407.123,
    height: 322.916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2396,
    result: "effect1_foregroundBlur_3933_36036"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3933_36036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 234,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBgMobile);
export default __webpack_public_path__ + "static/media/hero_bg_mobile.3b0a2f33acf7a990866d277cabe96c54.svg";
export { ForwardRef as ReactComponent };